import React from "react";

import moment from "moment";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";
import { Popover, OverlayTrigger, Modal } from "react-bootstrap";
import Toggle from "react-toggle";

import { isEnabled } from "utils/featureFlags";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import { LineInput } from "components/Inputs/LineInput";
import Slider from "components/Inputs/Slider/ProjectSlider";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import Waterfall from "components/Waterfall/Waterfall";

import CostsWaterfall from "components/Costs/Waterfall/CostsWaterfall";

import ProjectTitle from "components/UnifiedProject/ProjectTitle";
import ProjectHelpContainer from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import CurrentStateContainer from "containers/CurrentState/CurrentState";
import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import { TIME_PERIOD_OPTIONS, TIME_PERIOD_TRANSLATION } from "containers/Setup/reducer";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";
import BaselineCostsContainer from "containers/UnifiedProject/RealityCheck/BaselineCosts";
import ImpliedStrategy from "containers/UnifiedProject/RealityCheck/ImpliedStrategy";

import numeral from "numeral";

import styles from "./style.module.css";

export const PROJECT_MODES = {
  OVERALL: "Overall",
  DRILLDOWN: "Drilldown",
  VIEW_SEGMENTS: "View Subgroups"
};

export default class RealityCheck extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getLabelFromSegment(segment) {
    return segment.conditions.length === 0 ? "Overall" : segment.conditions[0].value;
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderAllBox() {
    const { id, setup, runId, updatePursuedCount, updateNotPursuedCount, updatePursuedRatio, updateNotPursuedRatio } =
      this.props;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";
    const notPursuedTransactionLabel = setup.notPursuedTransactionLabel
      ? setup.notPursuedTransactionLabel
      : "Potential " + transactionLabel;
    const trueAction = setup.trueAction ? setup.trueAction : "Pursue";
    const falseAction = setup.falseAction ? setup.falseAction : "Ignore";

    return (
      <div className={styles.realityBox} style={{ marginTop: "0px", maxWidth: "400px" }}>
        <div className={styles.bold}>{"Aible will try to reduce the " + transactionLabel + " you " + trueAction}</div>
        <div>
          <span>{"Since you do not "}</span>
          <span className={styles.bold}>{falseAction}</span>
          <span>{" any "}</span>
          <span className={styles.bold}>{notPursuedTransactionLabel}</span>
          <span>{" (you "}</span>
          <span className={styles.bold}>{trueAction}</span>
          <span>{" all "}</span>
          <span className={styles.bold}>{transactionLabel}</span>
          <span>{") Aible will identify "}</span>
          <span className={styles.bold}>{notPursuedTransactionLabel}</span>
          <span>{" to "}</span>
          <span className={styles.bold}>{falseAction}</span>
        </div>
      </div>
    );
  }

  renderNoneBox() {
    const { id, setup, runId, updatePursuedCount, updateNotPursuedCount, updatePursuedRatio, updateNotPursuedRatio } =
      this.props;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";
    const notPursuedTransactionLabel = setup.notPursuedTransactionLabel
      ? setup.notPursuedTransactionLabel
      : "Potential " + transactionLabel;
    const trueAction = setup.trueAction ? setup.trueAction : "Pursue";
    const falseAction = setup.falseAction ? setup.falseAction : "Ignore";

    return (
      <div className={styles.realityBox} style={{ marginTop: "0px", maxWidth: "400px" }}>
        <div className={styles.bold}>
          {"Aible will try to identify worthwhile " + transactionLabel + " to " + trueAction}
        </div>
        <div>
          <span>{"Since you do not "}</span>
          <span className={styles.bold}>{trueAction}</span>
          <span>{" any "}</span>
          <span className={styles.bold}>{transactionLabel}</span>
          <span>{" (you "}</span>
          <span className={styles.bold}>{falseAction}</span>
          <span>{" all "}</span>
          <span className={styles.bold}>{notPursuedTransactionLabel}</span>
          <span>{") Aible will identify "}</span>
          <span className={styles.bold}>{transactionLabel}</span>
          <span>{" to "}</span>
          <span className={styles.bold}>{trueAction}</span>
        </div>
      </div>
    );
  }

  renderRealityBox() {
    const { id, setup, runId, updatePursuedCount, updateNotPursuedCount, updatePursuedRatio, updateNotPursuedRatio } =
      this.props;

    const truePositive = setup.baselineCounts
      ? Math.round(setup.baselineCounts.truePositive)
      : Math.round(setup.truePositive);
    const falsePositive = setup.baselineCounts
      ? Math.round(setup.baselineCounts.falsePositive)
      : Math.round(setup.falsePositive);
    const trueNegative = setup.baselineCounts
      ? Math.round(setup.baselineCounts.trueNegative)
      : Math.round(setup.trueNegative);
    const falseNegative = setup.baselineCounts
      ? Math.round(setup.baselineCounts.falseNegative)
      : Math.round(setup.falseNegative);

    // const pursued = truePositive + falsePositive;
    // const notPursued = trueNegative + falseNegative;

    // const baselineTotal = pursued + notPursued;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const positives = Math.round(setup.truePositive) + Math.round(setup.falseNegative);
    const negatives = Math.round(setup.falsePositive) + Math.round(setup.trueNegative);

    // const total = positives + negatives;

    // const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(
    //   2
    // );

    // const notPursusedWinRate =
    //   falseNegative + trueNegative === 0
    //     ? 0
    //     : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    // const winRate =
    //   truePositive + falsePositive === 0
    //     ? 0
    //     : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : setup.truePositiveLabel
        : setup.outcomeLabel;

    return (positives === baselinePositives && negatives === baselineNegatives) ||
      (setup && setup.isRealityHammer === false) ? (
      <div />
    ) : (
      <div className={styles.realityBox} style={{ marginTop: "0px", maxWidth: "400px" }}>
        <div className={styles.bold}>{"Adjusted by Behavior Assumptions"}</div>
        <div>
          <span>{"Scenario adjusted "}</span>
          <span>{" by " + (positives > baselinePositives ? " adding " : " removing ")}</span>
          <span className={styles.bold}>
            {Math.abs(positives - baselinePositives) + " potential " + transactionLabel + " likely to " + outcomeLabel}
          </span>
          <span>{" and by " + (negatives > baselineNegatives ? " adding " : " removing ")}</span>
          <span className={styles.bold}>
            {Math.abs(negatives - baselineNegatives) +
              " potential " +
              transactionLabel +
              " unlikely to " +
              outcomeLabel}
          </span>
        </div>
      </div>
    );
  }

  renderWaterfall() {
    const {
      id,
      setup,
      runId,
      isEditBlueprint,
      updatePursuedCount,
      updateNotPursuedCount,
      updatePursuedRatio,
      updateNotPursuedRatio,
      updateBaselineConversionGain
    } = this.props;

    const truePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.truePositive)
        : Number(setup.truePositive);
    const falsePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falsePositive)
        : Number(setup.falsePositive);
    const trueNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.trueNegative)
        : Number(setup.trueNegative);
    const falseNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falseNegative)
        : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    // const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    // const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    // const baselinePositives = truePositive + falseNegative;
    // const baselineNegatives = falsePositive + trueNegative;

    // const total = positives + negatives;

    // const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(
    //   2
    // );

    const baselineTotalWinRate =
      bPositives + bNegatives > 0 ? ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2) : 0;

    const notPursusedWinRate =
      falseNegative + trueNegative === 0 ? 0 : ((falseNegative / (falseNegative + trueNegative)) * 100).toFixed(2);

    const winRate =
      truePositive + falsePositive === 0 ? 0 : ((truePositive / (truePositive + falsePositive)) * 100).toFixed(2);

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";
    const notPursuedTransactionLabel = setup.notPursuedTransactionLabel
      ? setup.notPursuedTransactionLabel
      : "Potential " + transactionLabel;
    const trueAction = setup.trueAction ? setup.trueAction : "Pursue";
    const falseAction = setup.falseAction ? setup.falseAction : "Ignore";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : setup.truePositiveLabel
        : setup.outcomeLabel;

    const isEditDisabled = isEditBlueprint !== true && this.props.isOverallSegment;

    return (
      <div className={styles.rWaterfall}>
        <div className={styles.waterfallLeft}>
          <div className={styles.wQuestion}>
            {"How many"}
            <span className={styles.rBold}>{transactionLabel + " "}</span>
            <span>{" do you"}</span>
            <span className={styles.rBold}>{trueAction}</span>
            <span>{"?"}</span>
            <div className={styles.wInput}>
              <LineInput
                isMediumBox
                value={pursued}
                onChange={(val) => updatePursuedCount(val.replace(/,/g, ""))}
                isDisabled={isEditDisabled}
              />
              <div style={{ marginRight: "15px" }}>{" with a "}</div>
              <div style={{ width: "80px" }}>
                <LineInput
                  isMediumBox
                  value={winRate}
                  onChange={(val) => updatePursuedRatio(val)}
                  isDisabled={isEditDisabled}
                />
              </div>
              <div style={{ marginLeft: "-6px" }}>{"% potential " + outcomeLabel + " rate"}</div>
            </div>
          </div>
          <div className={styles.wQuestion}>
            {"How many"}
            <span className={styles.rBold}>{notPursuedTransactionLabel + " "}</span>
            <span>{" do you"}</span>
            <span className={styles.rBold}>{falseAction}</span>
            <span>{"?"}</span>
            <div className={styles.wInput}>
              <LineInput
                isMediumBox
                value={notPursued}
                onChange={(val) => updateNotPursuedCount(val.replace(/,/g, ""))}
                isDisabled={isEditDisabled}
              />
              <div style={{ marginRight: "15px" }}>{" with a "}</div>
              <div style={{ width: "80px" }}>
                <LineInput
                  isMediumBox
                  value={notPursusedWinRate}
                  onChange={(val) => updateNotPursuedRatio(val)}
                  isDisabled={isEditDisabled}
                />
              </div>
              <div style={{ marginLeft: "-6px" }}>{"% potential " + outcomeLabel + " rate"}</div>
            </div>
          </div>
          <div className={styles.wQuestion}>
            <span style={{ fontWeight: "bold" }}>{"Baseline " + notPursuedTransactionLabel}</span>
            <div className={styles.wInput}>
              <LineInput isMediumBox value={baselineTotal} isDisabled />
              <div style={{ marginRight: "15px" }}>{" with a "}</div>
              <div style={{ width: "80px" }}>
                <LineInput isMediumBox value={baselineTotalWinRate} isDisabled />
              </div>
              <div style={{ marginLeft: "-6px" }}>{"% potential " + outcomeLabel + " rate"}</div>
            </div>
          </div>
          {this.getIsOverallSegment() !== true && isEnabled("baseline-costs") && false && (
            <BaselineCostsContainer runId={runId} />
          )}
        </div>
      </div>
    );
  }

  getIsNumerical(dataset) {
    return (
      dataset &&
      dataset.outcome &&
      dataset.fields &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "number"
    );
  }

  renderNumerical() {
    const { setup, madLibs, updateMadLibs, updateTransactionLabel, updateUnitType } = this.props;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    return (
      <div className={styles.realityHolder}>
        <div style={{ padding: "20px", paddingBottom: "0px" }}>{this.renderHelp()}</div>
        <div className={styles.realityMid}>
          <div className={styles.smallTitle} style={{ marginBottom: "0px" }}>
            {"What business terms would you like to use?"}
          </div>
          <div className={styles.cBox}>
            {"Customizing the businesss language here allows Aible to explain " +
              "the insights, predictions and recommendations in your own terms."}
          </div>
          <div className={styles.rMidInfo}>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The transactions represent"}
                value={transactionLabel}
                onChange={(val) => updateTransactionLabel(val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The number predicted is the"}
                value={madLibs ? madLibs.numberPredicted : ""}
                onChange={(val) => updateMadLibs("numberPredicted", val)}
              />
            </div>
            {/* <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={
                  <div>
                    <span>{"I want to optimize the Price of "}</span>
                    <span style={{ fontWeight: "bold" }}>
                      {transactionLabel}
                    </span>
                  </div>
                }
                value={madLibs ? madLibs.contAction : ""}
                onChange={(val) => updateMadLibs("contAction", val)}
              />
            </div> */}
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"The unit of measure is (USD, hours, etc.)"}
                value={setup.unitType !== undefined ? setup.unitType : "$"}
                onChange={(val) => updateUnitType(val)}
              />
            </div>
          </div>
          <div className={styles.rMidInfo} style={{ marginTop: "20px" }}>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"A prediction that is too low causes"}
                value={madLibs ? madLibs.underPredictAction : ""}
                onChange={(val) => updateMadLibs("underPredictAction", val)}
              />
            </div>
            <div className={styles.lineInputWidth}>
              <LineInput
                isMediumBox
                labelStyle={{ color: "#4B495B" }}
                topLabel={"A prediction that is too high causes"}
                value={madLibs ? madLibs.overPredictAction : ""}
                onChange={(val) => updateMadLibs("overPredictAction", val)}
              />
            </div>
          </div>
        </div>
        {/*<div className={styles.realityBot}>
          <div className={styles.smallTitle}>
            <div className={styles.rFlex}>
              <span>{`How many ${transactionLabel} do you process each`}</span>
              <span
                style={{
                  width: "200px",
                  marginLeft: "10px",
                  marginRight: "10px",
                }}
              >
                <Select
                  options={[
                    { value: "Month", label: "Month" },
                    { value: "Day", label: "Day" },
                    { value: "Week", label: "Week" },
                    { value: "Quarter", label: "Quarter" },
                    { value: "Year", label: "Year" },
                  ]}
                  defaultValue={[{ value: "Month", label: "Month" }]}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 200,
                    }),
                  }}
                />
              </span>
              <span>{`?`}</span>
            </div>
          </div>
          {isEditDisabled ? (
            <div className={styles.subTitle}>{"Select a subgroup to edit"}</div>
          ) : (
            <div />
          )}
          <div className={styles.rWaterfall}>
            <div className={styles.wInput}>
              <LineInput
                isMediumBox
                value={count}
                //onChange={(val) => updatePursuedCount(val.replace(/,/g, ''))}
                isDisabled={isEditDisabled}
              />
              <div
                style={{ marginRight: "15px" }}
              >{`${transactionLabel} with a `}</div>
              <div style={{ width: "160px" }}>
                <LineInput
                  isMediumBox
                  value={average}
                  //onChange={(val) => updatePursuedRatio(val)}
                  isDisabled={isEditDisabled}
                />
              </div>
              <div style={{ marginLeft: "-6px" }}>{" average"}</div>
            </div>
          </div>
          </div>*/}
      </div>
    );
  }

  renderHelp() {
    const {} = this.props;
    return (
      <ProjectHelpContainer title={"Validate Expected Behavior"} subtitle={"Why are we asking these questions?"}>
        <ProjectHelpItem type={"mind"}>
          {"Adding business terms improves the clarity " + "of the insights, predictions and recommendations."}
        </ProjectHelpItem>
        <ProjectHelpItem type={"target"}>
          {"Validating the behavior ensures that " + "the AI is trained on an expected reality."}
        </ProjectHelpItem>
        <ProjectHelpItem type={"warning"}>
          {"If the data doesnt reflect reality, which is a common problem in AI tools, " +
            "the AI will attempt to optimize for an incorrect goal."}
        </ProjectHelpItem>
      </ProjectHelpContainer>
    );
  }

  render() {
    const {
      id,
      runId,
      setup,
      dataset,
      blueprint,
      isNext,
      isModelsNext,
      isEditBlueprint,
      isOverallSegment,
      hideModel,
      outcomeWinRate,
      updateOutcomeLabel,
      updateTransactionLabel,
      updateAdvancedRevenueLabel,
      updateNotPursuedTransactionLabel,
      updateTrueAction,
      updateFalseAction,
      updateCountType,
      updateUnitType,
      updateTimePeriod,
      timePeriod,
      timePeriodSelection,
      isBaselineRealityHammer,
      updateIsBaselineRealityHammer,
      isNextBlueprintEdit,
      nextBlueprint
    } = this.props;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const isNumerical = this.getIsNumerical(dataset);

    if (isNumerical) {
      return this.renderNumerical();
    }

    const isEditDisabled = isEditBlueprint !== true && this.props.isOverallSegment;

    const TP =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.truePositive : setup.truePositive;
    const FP =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.falsePositive : setup.falsePositive;
    const FN =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.falseNegative : setup.falseNegative;
    const TN =
      setup && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts.trueNegative : setup.trueNegative;

    const isAll = Number(TN) + Number(FN) === 0 && Number(setup.truePositive) + Number(FP) > 0;
    // const isSome =
    //   (Number(TN) + Number(FN) > 0 && Number(TP) + Number(FP) > 0) ||
    //   Number(TP) + Number(FP) + Number(TN) + Number(FN) === 0;
    const isNone = Number(TP) + Number(FP) === 0 && Number(TN) + Number(FN) > 0;
    const timePeriodDisplayText = TIME_PERIOD_TRANSLATION[timePeriod];

    const retBp = isNextBlueprintEdit || !blueprint ? nextBlueprint : blueprint;

    let rowCount;
    if (dataset?.rowCount !== undefined) {
      rowCount = dataset.rowCount;
    } else if (retBp !== undefined) {
      let bpDataset = retBp?.wizard?.dataset;
      rowCount = bpDataset?.rowCount;
    }

    let winRate;
    if (setup?.success !== undefined) {
      winRate = outcomeWinRate;
    } else if (retBp !== undefined) {
      let success = retBp?.wizard?.setup?.success;
      if (success !== undefined) {
        let count = 0;
        if (Array.isArray(success)) {
          for (const s of success) {
            count += s.count;
          }
        } else {
          count += success.count;
        }
        if (!isNaN(count) && !isNaN(rowCount) && rowCount >= count) {
          winRate = ((100 * count) / (rowCount || 1)).toFixed(2);
        }
      }
    }

    return (
      <div className={styles.realityHolder} style={isModelsNext ? { width: "100%" } : isNext ? { width: "100%" } : {}}>
        <div className={styles.realityTop}>
          <div className={styles.largeTitle} style={{ marginBottom: "5px" }}>
            {"What are the characteristics of the " + transactionLabel + " you expect to predict?"}
          </div>
          <div className={styles.sTitle}>
            {"Aible helps you create an AI that does well in the way you plan " +
              "to use the AI rather than one that only does well on the training data."}
          </div>
        </div>
        <div className={styles.realityBot}>
          <div className={styles.smallTitle}>
            <div className={styles.rFlex}>
              <span>{"How many " + transactionLabel + " do you expect to predict in a "}</span>
              <span
                style={{
                  width: "200px",
                  marginLeft: "10px",
                  marginRight: "10px"
                }}
              >
                <Select
                  options={TIME_PERIOD_OPTIONS}
                  value={timePeriodSelection}
                  onChange={(s) => updateTimePeriod(s.value)}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 200
                    })
                  }}
                />
              </span>
            </div>
          </div>
          <div className={styles.dBox}>
            {"How you expect to use the AI may be different than what is in the dataset. " +
              "Aible needs to know if your expected"}
            {timePeriodDisplayText ? (
              <span className={styles.rBold}>{timePeriodDisplayText + " "}</span>
            ) : (
              <React.Fragment />
            )}
            {`behavior is different than the ${rowCount ? rowCount + " " : ""}values and ${winRate !== undefined ? winRate + "% " : ""}positive rate found in the dataset.`}
          </div>
          {isEditDisabled ? (
            <div
              style={{
                fontWeight: "bold",
                marginBottom: "20px",
                fontSize: "16px",
                display: "flex",
                alignItems: "center"
              }}
            >
              <Icon type={"info"} />
              <div style={{ marginLeft: "8px" }}>{"Select a subgroup to update expected behavior"}</div>
            </div>
          ) : (
            <div />
          )}
          {this.renderWaterfall()}
        </div>
        {this.renderRealityBox()}
        {isAll && this.renderAllBox()}
        {isNone && this.renderNoneBox()}
        {/* <ImpliedStrategy id={id} /> */}
        {isOverallSegment !== true && (
          <div style={{ marginLeft: "20px", marginTop: "20px" }}>
            <div className={styles.baselineToggle}>
              <div className={styles.baselineLabel}>
                {"Would you like your baseline costs and benefits to match your selected scenario?"}
              </div>
              <div id={"eToggle"} className={styles.baselineToggleHolder}>
                <Toggle
                  checked={isBaselineRealityHammer === true}
                  icons={false}
                  onChange={(e) => updateIsBaselineRealityHammer(!isBaselineRealityHammer)}
                />
                <span className={isBaselineRealityHammer === true ? styles.baselineYPos : styles.baselineNPos}>
                  {isBaselineRealityHammer !== true ? "Yes" : "No"}
                </span>
              </div>
            </div>

            {isBaselineRealityHammer && <BaselineCostsContainer {...this.props} baseline />}
          </div>
        )}
        {hideModel !== true && (
          <div className={styles.modelBox} style={isNext ? { left: "27%", width: "440px", top: "110px" } : {}}>
            <ModelBoxContainer id={id} runId={runId} hideFooter />
          </div>
        )}
      </div>
    );
  }
}
